import React from "react";
import { withRouter, Link } from "react-router-dom";
import { inject, observer } from "mobx-react";
import queryString from "query-string";
import Cookies from "js-cookie";
import Container from "reactstrap/lib/Container";
import userInfo from "Services/UserInfo";
import Metrika from "Services/Metrika";
import { sendMetriks } from "Services/sendMetriks";
import { generateUrl } from "Services/withDefaultParams";
import Routes from "Configs/routes";
import { EVENT_CATEGORY_CLICK_BUTTON } from "Constants/metriks/GoogleCategorys";
import { CLICK_SEND_ORDER_WITHOUT_TARIFF } from "Constants/metriks/Yandex";
import FormLayout from "Layouts/FormLayout";
import { SelectField } from "ComponentsUI/Selectfield";
import { TextField } from "ComponentsUI/TextField";
import Button from "ComponentsUI/Button";
import TermsOfUse from "ComponentsUI/TermsOfUse";
import SuccessForm from "./SuccessForm";
import AlertWrapper from "ComponentsUI/AlertWrapper";
import { addAddressData, addABData, addRefererData } from "Utils";

@withRouter
@inject("ApplicationModel")
@observer
export default class FormContainer extends React.Component {
	constructor(props) {
		super(props);
		const { text } = this.props.ApplicationModel;

		this.selectorVariants = [
			{
				id: 0,
				name: text.OUTHOME_ORDER_VARIANT_1,
			},
			{
				id: 1,
				name: text.OUTHOME_ORDER_VARIANT_2,
			},
			{
				id: 2,
				name: text.OUTHOME_ORDER_VARIANT_3,
			},
			{
				id: 3,
				name: text.OUTHOME_ORDER_VARIANT_4,
			},
			{
				id: 4,
				name: text.OUTHOME_ORDER_VARIANT_5,
			},
		];

		this.errorsText = {
			name: text.ERROR_MESSAGE_UNCORRECT_NAME,
			phone: text.ERROR_MESSAGE_UNCORRECT_PHONE,
			nameAndPhone: text.ERROR_MESSAGE_UNCORRECT_NAME_AND_PHONE,
		};

		this.state = {
			fio: {
				error: false,
				value: "",
			},
			phone_connection: {
				error: false,
				value: "",
			},
			selectedVariant: this.selectorVariants[4],
			currentErrorText: "",
			focusingInput: 0,
		};
	}
	inputRef = null;

	componentDidMount() {
		// Поставить авфтофокус на инпуте для декстопа
		if (!this.state.focusingInput) {
			let windowSizes = this.props.windowSizes;
			let windowDekstop = (windowSizes?.md || windowSizes?.lg) && windowSizes.height > 0;
			let inputRef = this.inputRef;
			if (this.props.autoFocus && inputRef && windowDekstop) {
				inputRef.focus();
				this.changeStateFocusInput();
			}
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		// Поставить авфтофокус на инпуте, если он не ставился и его нужно установить
		if (!this.state.focusingInput) {
			let prevPropsWindowSizes = prevProps.windowSizes;
			let windowSizes = this.props.windowSizes;
			let inputRef = this.inputRef;
			if (
				this.props.autoFocus &&
				inputRef &&
				(windowSizes?.md || windowSizes?.lg) &&
				(prevPropsWindowSizes?.md || prevPropsWindowSizes?.lg)
			) {
				inputRef.focus();
				this.changeStateFocusInput();
			} else if (this.props.autoFocus && inputRef && (windowSizes.xs || windowSizes?.sm)) {
				this.changeStateFocusInput();
			}
		}
	}

	changeStateFocusInput() {
		this.setState({ focusingInput: 1 });
	}

	onChangeFioHandler(e) {
		this.setState({
			fio: {
				error: false,
				value: e.target.value,
			},
			currentErrorText: "",
		});
	}

	onChangePhoneHandler(e) {
		this.setState({
			phone_connection: {
				error: false,
				value: e.target.value,
			},
			currentErrorText: "",
		});
	}

	getErrorText(isFioInvalid, isPhoneInvalid) {
		if (isFioInvalid && isPhoneInvalid) {
			return this.errorsText.nameAndPhone;
		}

		if (isFioInvalid) {
			return this.errorsText.name;
		} else if (isPhoneInvalid) {
			return this.errorsText.phone;
		}

		return "";
	}

	onClickConnectHandler() {
		let fio = this.state.fio.value;
		let phone_connection = this.state.phone_connection.value;
		let sendingStore = this.props.ApplicationModel.sendingStore;
		let commonViewModel = this.props.ApplicationModel.commonViewModel;

		const isFioInvalid = fio.length < 2;
		const isPhoneInvalid = !sendingStore.validatePhone(phone_connection);

		if (isFioInvalid || isPhoneInvalid) {
			Metrika.getInstance().google.sendEvent(EVENT_CATEGORY_CLICK_BUTTON, "click_error_request");
			this.setState({
				...this.state,
				fio: {
					...this.state.fio,
					error: isFioInvalid,
				},
				phone_connection: {
					...this.state.phone_connection,
					error: isPhoneInvalid,
				},
				currentErrorText: this.getErrorText(isFioInvalid, isPhoneInvalid),
			});

			return null;
		} else {
			commonViewModel.changeFormOuthomeSendFlag(true);

			const {
				ApplicationModel: { currentRegion, tariffsModel },
				location: { search },
			} = this.props;

			let data = {
				fio: fio,
				phone_connection: phone_connection,
				region_id: currentRegion.id,
				lead_form_type: userInfo(CLICK_SEND_ORDER_WITHOUT_TARIFF),
				info: this.state.selectedVariant.name,
				utm_campaign: Cookies.get("utm_campaign"),
				utm_medium: Cookies.get("utm_medium"),
				utm_source: Cookies.get("utm_source"),
				utm_content: Cookies.get("utm_content"),
				utm_term: Cookies.get("utm_term"),
			};
			if (search) {
				let getParams = queryString.parse(search);
				if (getParams.provider_id) {
					data.provider_id = getParams.provider_id;
				}
			}

			data = addAddressData(data, this.props.ApplicationModel);
			data = addABData(data);
			data = addRefererData(data, this.props.ApplicationModel);

			sendMetriks("CLICK_SEND_ORDER_WITHOUT_TARIFF");
			data.ga_client_id = Metrika.getInstance().google.getCID();
			sendMetriks("LEAD_ALL");
			tariffsModel.sendOrderSAT(data);
		}
	}

	changeSelectedVariant(item) {
		this.setState({
			selectedVariant: item,
		});
	}

	_renderForm() {
		const { text } = this.props.ApplicationModel;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		return (
			<>
				<AlertWrapper error={this.state.currentErrorText} center={true}>
					<FormLayout>
						<TextField
							inputRef={(ref) => (this.inputRef = ref)}
							autocomplete="name"
							name="name"
							size={"big"}
							greyPlaceholder={true}
							onEnter={() => {
								this.onClickConnectHandler();
							}}
							placeholder={text.orderName}
							onChange={(e) => {
								this.onChangeFioHandler(e);
							}}
							withOpacity={true}
							inputBackgroundColor={"transparent"}
							datatest="order_form_input_name"
							whiteTextField={true}
							isError={this.state.fio.error}
						/>
						<TextField
							autocomplete="tel"
							name="tel"
							size={"big"}
							withOpacity={true}
							greyPlaceholder={true}
							onChange={(e) => {
								this.onChangePhoneHandler(e);
							}}
							onEnter={() => {
								this.onClickConnectHandler();
							}}
							type={"phone"}
							placeholder="+7"
							inputBackgroundColor={"transparent"}
							datatest="order_form_input_tel"
							whiteTextField={true}
							isError={this.state.phone_connection.error}
						/>
						<SelectField
							multiselect={false}
							windowSizes={windowSizes}
							items={this.selectorVariants}
							onlyInputDisabled={true}
							transparentType={true}
							inHeroBannerView={true}
							onItemSelect={(items) => this.changeSelectedVariant(items[0])}
							text={text}
							whiteTheme={this.props.whiteTheme}
							withoutClose={true}
							findItems={[this.state.selectedVariant]}
							placeholder={""}
							activePlaceHolder={""}
						/>
						<Button
							datatest="order_form_input_connect_button"
							fullWidth={true}
							noPaddings={true}
							typeText={"verybig"}
							status="purple"
							size="big"
							onClick={() => {
								this.onClickConnectHandler();
							}}
						>
							{text.orderConnect}
						</Button>
					</FormLayout>
				</AlertWrapper>
				<TermsOfUse isOutHome={true} buttonText={text.orderConnect} />
			</>
		);
	}

	_renderSuccess() {
		let text = this.props.ApplicationModel.text;
		let url = generateUrl(Routes.AddReview.route, {
			regionUrl: this.props.match.params.regionUrl,
		});
		let button = (
			<Link to={url}>
				<Button status={"purple"} datatest={"give_feedback"}>
					{text.ratingLeaveReview}
				</Button>
			</Link>
		);
		return (
			<Container>
				<SuccessForm text={text} button={button} />
			</Container>
		);
	}

	render() {
		let formOuthomeWasSended = this.props.ApplicationModel.commonViewModel.formOuthomeWasSended;
		return !formOuthomeWasSended ? this._renderForm() : this._renderSuccess();
	}
}
